import React from 'react';
import { TranslatedBadge } from './translated_badge';

function TyroolasChoiceBadge({ color }) {
    return (
        <TranslatedBadge type="tyroolas-choice" translationKey="badge-tyroolas-choice" color={color} />
    );
}

export { TyroolasChoiceBadge };
